// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'webpack-zepto';
import FastClick from 'fastclick';
import store from './store/store';

$.ajaxSettings.crossDomain = true;
FastClick.attach(document.body);

Vue.config.productionTip = false


/* eslint-disable no-new */
window.vue = new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App}
})

//swiper
import AwesomeSwiper from 'vue-awesome-swiper'
Vue.use(AwesomeSwiper)


//注入title指令，router切换时，改变title
Vue.directive('title', {
    inserted: function (el, binding) {
        if (binding.value) {
            document.title = binding.value;
        }
    },
});



//toast
import toast from "./components/toast/toast.js"

function showToast(msg) {
    toast({
        message: msg,
        duration: 2800
    });
}


let loginUrl = '//passport.m.jd.com/user/login.action?v=1&returnurl='
let currentUrl = window.location.href.split("#/")[0]

//网关错误
vue.$on("gateWayError", (res) => {

    if(res.resultCode == "3") {
        window.location.href = loginUrl + encodeURIComponent(currentUrl);
    }else {
        //toast({message: res.resultMsg});
        console.error(res.resultMsg)
        //网关接口异常、系统错误页
        router.push({"name": "result", params: {type: 'exception'}})
    }

});

//业务错误
vue.$on("bizError", showToast);

//服务器错误
vue.$on("serverError", showToast);


//分享
share && share.setShare({
    "title": "白条权益中心",
    "desc": "点击查看我的白条活跃度，领6期息费优惠券，能打能玩的白条，乐享权益！",
    "link": (window.location.origin + window.location.pathname),
    "imgUrl": "https://storage.jd.com/static-res/consumer/baitiaohome/images/shareimg.png"
})



// WEBPACK FOOTER //
// ./src/main.js